import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Icon,
  TableFooter,
  TablePagination,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { LOCALE } from "../../../properties/Locale";
import { useDispatch } from "react-redux";
import { changePageTitle } from "../../../common/actions/CommonActions";
import { VacancyRepository } from "../../vacancy/VacancyRepository";
import { VacancyAppRepository } from "../VacancyAppRepository";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import CardBody from "../../../common/components/Card/CardBody";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import moment from "moment";
import FileIcon, { defaultStyles } from "react-file-icon";
import { Redirect } from "react-router-dom";
import { Close, CloudDownload, CloudUpload } from "@material-ui/icons";
import { AuthService } from "../../../auth/AuthService";
import { DropzoneArea } from "material-ui-dropzone";

export default function RankListComponent() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [vacancyApps, setVacancyApps] = React.useState();
  const [totalAppsRemaining, setTotalAppsRemaining] = React.useState(0);
  const [redirect, setRedirect] = React.useState();
  const [vacancies, setVacancies] = useState();
  const [selectedVacancy, setSelectedVacancy] = useState("");
  const [attachment, setAttachment] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [file, setFile] = useState();
  const [updatedVacancyApps, setUpdatedVacancyApps] = useState();
  const [type, setType] = useState("");
  const currentUser = AuthService.getCurrentUser();

  React.useEffect(() => {
    dispatch(changePageTitle(`${LOCALE.view_rank_lists}`));
  }, [dispatch]);

  React.useEffect(() => {
    getListOfVacancyApps();
  }, [selectedVacancy]);

  const getListOfVacancyApps = () => {
    setTotalAppsRemaining();
    VacancyAppRepository.getRankListForVacancy(selectedVacancy).then(
      (response) => {
        if (
          (response.data != null || response.data != undefined) &&
          response.data.length != 0
        ) {
          setVacancyApps();
          setTotalAppsRemaining(response.data.length);
          setUpdatedVacancyApps(response.data);
          setType("rankListApp");
          console.log(response.data);
        } else {
          VacancyAppRepository.getAllVacancyAppsFulfillingConditions(
            selectedVacancy
          ).then((res) => {
            setUpdatedVacancyApps();
            setTotalAppsRemaining(res.data.length);
            setVacancyApps(res.data);
            setType("vacancyApp");
          });
        }
      }
    );
  };

  React.useEffect(() => {
    VacancyRepository.fetchAllVacancy({
      page: 0,
      size: 100,
      orderBy: "dateCreated",
      orderDirection: "DESC",
    }).then((res) => {
      setVacancies(res.data.content);
    });
  }, []);

  const handleExcelDownload = async () => {
    try {
      const response = await VacancyAppRepository.exportApplicationsToExcel(
        selectedVacancy,
        type
      );
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `export_${selectedVacancy}_${formattedDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download file:", err);
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleChangeFile = (file) => {
    setFile(file[0]);
  };

  const handleSubmitFile = () => {
    VacancyAppRepository.uploadFile(selectedVacancy, file)
      .then((res) => {
        getListOfVacancyApps();
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      {redirect && <Redirect to={redirect} />}
      <Grid container spacing={3} justify="space-between">
        <Grid item xs={4}>
          <FormControl
            className={classes.formControl}
            variant="outlined"
            size="small"
            fullWidth
          >
            <InputLabel id="demo-simple-select-label1">
              {LOCALE.choose_vacancy}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label1"
              id="demo-simple-select1"
              label={LOCALE.choose_vacancy}
              value={selectedVacancy}
              onChange={(e) => setSelectedVacancy(e.target.value)}
            >
              <MenuItem key={221312} value={""}>
                {LOCALE.all}
              </MenuItem>
              {vacancies?.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {selectedVacancy &&
          !currentUser.authorities
            .map((auth) => auth.authority)
            .includes("ROLE_ADMINISTRATION") && (
            <Grid item xs={2}>
              <Button
                color="secondary"
                startIcon={<CloudUpload />}
                onClick={handleDialogOpen}
              >
                {LOCALE.update_rank_list_data}
              </Button>
            </Grid>
          )}
      </Grid>
      <br></br> <br></br>
      <Card>
        <CardHeader color="theme">
          <Grid container justify={"space-between"}>
            <Typography>
              {LOCALE.rank_list_candidates_fulfilled_conditions}
            </Typography>
            {selectedVacancy && (
              <Grid item>
                <Tooltip title="Преземи ранг листа">
                  <IconButton
                    style={{
                      color: "white",
                    }}
                    onClick={() => {
                      handleExcelDownload();
                    }}
                  >
                    <CloudDownload />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
          <Typography style={{ float: "right" }}>
            {LOCALE.total}: {totalAppsRemaining}
          </Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="users table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.number}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.municipality}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.school}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.name_and_surname_applicant}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.points_from_bureau}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.point_from_professional_development}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.points_from_educational_center}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.total_points}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {updatedVacancyApps && updatedVacancyApps.length > 0 ? (
                updatedVacancyApps?.map((updatedVacancyApp, index) => (
                  <TableRow
                    key={index}
                    style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{updatedVacancyApp.municipality}</TableCell>
                    <TableCell>{updatedVacancyApp.school}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {updatedVacancyApp.fullName}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {updatedVacancyApp.broCsooPoints.toFixed(1) || 0}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {updatedVacancyApp.professionalDevelopmentPoints.toFixed(
                        1
                      ) || 0}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {updatedVacancyApp.schoolPoints.toFixed(1) || 0}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {updatedVacancyApp.totalPoints.toFixed(1) || 0}
                    </TableCell>
                  </TableRow>
                ))
              ) : vacancyApps && vacancyApps.length > 0 ? (
                vacancyApps?.map((vacancyApp, index) => (
                  <TableRow
                    key={index}
                    style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell>{index + 1}</TableCell>

                    <TableCell>
                      {vacancyApp.basicInfo.municipality.name}
                    </TableCell>
                    <TableCell>{vacancyApp.basicInfo.school.name}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.basicInfo.firstName +
                        " " +
                        vacancyApp.basicInfo.lastName}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.bureauGrading?.points.toFixed(1) || 0}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.professionalDevelopment?.points.toFixed(1) ||
                        0}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.schoolGrading?.points.toFixed(1) || 0}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.totalPoints.toFixed(1) || 0}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>
                    {LOCALE.no_apps_for_evaluating}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {openDialog && (
        <Dialog
          open={openDialog}
          maxWidth="md"
          fullWidth={true}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DropzoneArea
              multiple={false}
              onChange={(file) => handleChangeFile(file)}
              previewChipProps={false}
              showFileNamesInPreview={false}
              showPreviews={false}
              showPreviewsInDropzone={false}
              filesLimit={1}
              dropzoneText={LOCALE.dropzoneText}
              acceptedFiles={[".xls", ".xlsx"]}
            ></DropzoneArea>

            {file && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {LOCALE.fileType}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {LOCALE.fileName}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {LOCALE.fileSize}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {LOCALE.actions}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableCell>
                    <FileIcon
                      size={50}
                      extension={file.name.split(".").pop()}
                      {...defaultStyles[file.name.split(".").pop()]}
                    />
                  </TableCell>
                  <TableCell>
                    {file.name.split(".").slice(0, -1).join(".")}
                  </TableCell>
                  <TableCell>{(file.size / 1024).toFixed(2)} KB</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        setFile();
                      }}
                    >
                      <Close style={{ color: "red" }} />
                    </IconButton>
                  </TableCell>
                </TableBody>
              </Table>
            )}
          </DialogContent>

          <DialogActions>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setFile();
                handleDialogClose();
              }}
            >
              Откажи
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleDialogClose();
                handleSubmitFile();
                setFile();
              }}
              autoFocus
            >
              Зачувај
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
